module.exports = "/timeclock/directives/clockOutMap-ffa089.html";